export default {
  companyLabel: "About Us",
  banners: {
    ceo: { title: "CEO Message", subtitle: "A technology partner that solves customer challenges" },
    overview: { title: "Company Overview", subtitle: "Building trust through half a century of technology" },
    history: { title: "History", subtitle: "Half a century of growth from 1975 to the present" },
    certifications: { title: "Certifications", subtitle: "Quality competitiveness proven by international standards" },
    location: { title: "Location", subtitle: "Headquarters and factory in Siheung, Gyeonggi-do" },
  },
  historyYearSuffix: "",
  subNav: [
    { label: "CEO Message", to: "/about/ceo", icon: "ri-user-star-line" },
    { label: "Company Overview", to: "/about/overview", icon: "ri-building-line" },
    { label: "History", to: "/about/history", icon: "ri-calendar-check-line" },
    { label: "Certifications", to: "/about/certifications", icon: "ri-shield-check-line" },
    { label: "Location", to: "/about/location", icon: "ri-map-pin-2-line" },
  ],
  ceo: {
    name: "Lee Nam-jae",
    title: "CEO",
    greeting: "We will be your technology partner in solving customer challenges.",
    body: "Thank you for visiting the Hankuk Rubber Tech. Co., Ltd. website.\n\nSince our founding in 1975, Hankuk Rubber Tech has walked a single path of rubber product manufacturing for nearly half a century. Guided by the belief that \"Having trouble with rubber products? We will solve it for you.\", we have grown beyond a simple parts supplier into a technology partner that analyzes our customers' technical challenges and proposes optimal solutions.\n\nFifty years of expertise and know-how accumulated in compression molding are the foundation of our quality and trust. Handling various rubber materials including EPDM, NBR, CR, SBR, FKM, and silicone rubber, we supply customized rubber parts across all industries from automotive and heavy industry to electronics, chemicals, and shipbuilding.\n\nThrough continuous technological innovation and quality improvement, we will remain a reliable companion in building our customers' success.\n\nThank you.",
    signature: "Hankuk Rubber Tech. Co., Ltd. CEO Lee Nam-jae",
  },
  overview: {
    name: "Hankuk Rubber Tech. Co., Ltd.",
    enName: "HANKUK RUBBER TECH. CO.,LTD.",
    established: "April 1975",
    ceo: "Lee Nam-jae",
    employees: "85",
    factoryArea: "6,600㎡",
    annualRevenue: "KRW 12 billion / year",
    businessType: "Rubber product manufacturing and wholesale/retail",
    companyInfoTitle: "Company Information",
    facilityTitle: "Key Production Facilities",
    productsTitle: "Main Products",
    coreValuesTitle: "Core Values",
    visionLabel: "VISION",
    missionLabel: "MISSION",
    rows: [
      { label: "Company Name", value: "Hankuk Rubber Tech. Co., Ltd." },
      { label: "English Name", value: "HANKUK RUBBER TECH. CO.,LTD." },
      { label: "Established", value: "April 1975" },
      { label: "CEO", value: "Lee Nam-jae" },
      { label: "Business Type", value: "Rubber product manufacturing and wholesale/retail" },
    ],
    mainProducts: [
      "Industrial O-Ring",
      "Industrial Diaphragm",
      "Custom Diaphragm",
      "Heat Exchanger Gasket",
      "Automotive Rubber Boots / Bellows",
      "Silicone Valve Seat / Ring",
      "Precision Rubber Parts",
      "Food Processing Products",
      "Suction Cups",
    ],
    facilities: [
      { name: "Compression Molding Press", spec: "50 to 1,200 tons", count: "24 units" },
      { name: "Rubber Kneader", spec: "Kneader", count: "1 unit" },
      { name: "OPEN ROLLER", spec: "14inch×16inch", count: "2 units" },
      { name: "Physical Property Tester", spec: "Tensile · Hardness · Aging", count: "6 types" },
    ],
    vision: "Korea's leading rubber product solution partner that solves customers' technical challenges",
    mission: "Contributing to industrial advancement through innovation in compression molding rubber technology",
    coreValues: [
      { label: "Quality First", desc: "No trust without perfect quality" },
      { label: "Technology Innovation", desc: "Pushing beyond limits through relentless R&D" },
      { label: "Customer Partnership", desc: "The customer's problem is our task" },
      { label: "Trust Management", desc: "Promising the future on 50 years of history" },
    ],
    detail: "View Details",
  },
  history: [
    { year: 1975, month: 0, content: "Founded as Hankuk Chemical Rubber" },
    { year: 1978, month: 0, content: "Developed plate gaskets for heat exchangers" },
    { year: 1980, month: 0, content: "Developed tractor parts" },
    { year: 1991, month: 0, content: "Participated in the national car development project" },
    { year: 2002, month: 0, content: "Relocated (industrial complex) and renamed to Hankuk Rubber Tech" },
    { year: 2002, month: 0, content: "Developed crash stop for hard disk drives (for Samsung Electronics)" },
    { year: 2008, month: 0, content: "Obtained ISO 9001 certification" },
    { year: 2011, month: 0, content: "Developed large sluice gate packing" },
    { year: 2012, month: 0, content: "Supplied valve seals for the Panama Canal" },
    { year: 2014, month: 0, content: "Obtained TS 16949 (now IATF 16949) certification" },
    { year: 2018, month: 0, content: "Mass production of waterproof gaskets for EV power packs" },
  ],
  certifications: [
    {
      name: "ISO 9001",
      fullName: "Quality Management System",
      year: "First obtained in 1998",
      desc: "An international quality management standard established by the ISO, certifying that we have a management system capable of delivering consistent quality products and services.",
      icon: "ri-shield-check-line",
    },
    {
      name: "IATF 16949",
      fullName: "Automotive Quality Management",
      year: "First obtained in 2008",
      desc: "An international quality management standard specialized for the automotive industry, certifying that we meet the rigorous quality control requirements for automotive parts manufacturers.",
      icon: "ri-car-line",
    },
    {
      name: "R&D Division",
      fullName: "Corporate Research Institute",
      year: "Obtained in 2013",
      desc: "A corporate research institute certified by KOITA, officially recognizing our systematic R&D capabilities and dedicated research personnel.",
      icon: "ri-flask-line",
    },
  ],
  location: {
    address: "36, Okguseocheon-ro 237beon-gil, Siheung-si, Gyeonggi-do, Korea",
    postalCode: "15048",
    tel: "031-434-0341",
    fax: "031-434-0340",
    email: "hkrubbert@naver.com",
    mapEmbed: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3170.597620348084!2d126.738!3d37.375!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b7a1c0a1c0a1b%3A0x0!2z6rK96riw64-EIOyLnO2dkOyLnCDsmKXqtazsspzshJzroZwgMjM367iY6ri4IDM2!5e0!3m2!1sko!2skr!4v1710000000000" width="100%" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
    subway: "Seoul Metro Line 4 Jeongwang Station (25 min walk / 5 min taxi)",
    bus: "Buses 7, 22, 31-3, 61 - get off at Jeongwang-dong Community Center (5 min walk)",
    parking: "On-site parking available (30 cars and 5 large trucks simultaneously)",
    contactTitle: "Contact & Address",
    transportTitle: "Transportation Guide",
    mapTitle: "Map",
    labels: {
      address: "Address",
      tel: "Phone",
      fax: "Fax",
      email: "Email",
      subway: "Subway",
      bus: "Bus",
      parking: "Parking",
    },
  },
  coming: {
    title: "The About page is coming soon",
    subtitle: "You will soon be able to explore rich company information including our history timeline, directions, and vision.",
    description: "We will complete this page in the next step.",
  },
};